export default "__VITE_ASSET__a55f791b__"